<mat-label *ngIf="singleDropdownData.title" [ngClass]="singleDropdownData.titleClass">{{singleDropdownData.title}}</mat-label><br>
<ng-select class="width-100" (change)="chosenOptions()" [(ngModel)]="selectedValues" placeholder="{{singleDropdownData.placeholder}}">
    <ng-option *ngFor="let item of singleDropdownData.values" [value]="item" placeholder="this is a test">{{item}}</ng-option>
</ng-select>
<br>